var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',_vm._b({},'v-chip',_vm.settings,false),[_vm._v(" "+_vm._s(_vm.mwutils.prettyPrint(_vm.value, "TITLE"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }